import React from "react";
import DashboardLayout from "../layout/DashboardLayout";
import Dashboard from "../pages/dashboard";
import Aggregator from "../pages/aggregator";
import Collector from "../pages/collector";
import Transaction from "../pages/transaction";
import User from "../pages/user";
import Offtake from "../pages/waybill";
import Admin from "../pages/admin";
import AdminDashboard from "../pages/admin/dashboard/Dashboard";
import AuthGuard from "../route-guard/AuthGuard";
import Collection from "../pages/collection";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBondary";
import Offtaker from "../pages/offtaker";

export const getDashboardRouter = () => {
  return [
    {
      path: "/",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      errorElement: <ErrorBoundary />,
      children: [
        {
          children: [
            {
              path: "/dashboard",
              element: <Dashboard />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "/collector",
              element: <Collector />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "/offtaker",
              element: <Offtaker />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "/transaction",
              element: <Transaction />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "/user",
              element: <User />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "/offtake",
              element: <Offtake />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "collection",
              element: <Collection />,
              // errorElement: <ErrorBoundary />,
            },
            // {
            //   path: "/dashboard/:modelId",
            //   element: <DashboardLayout />,
            //   errorElement: <ErrorPage />,
            // },
          ],
        },
      ],
    },
    {
      path: "admin",
      element: (
        <AuthGuard>
          <Admin />
        </AuthGuard>
      ),
      errorElement: <ErrorBoundary />,
      children: [
        {
          children: [
            {
              path: "dashboard",
              element: <AdminDashboard />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "aggregator",
              element: <Aggregator />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "collector",
              element: <Collector />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "offtaker",
              element: <Offtaker />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "transaction",
              element: <Transaction />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "user",
              element: <User />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "offtake",
              element: <Offtake />,
              // errorElement: <ErrorBoundary />,
            },
            {
              path: "collection",
              element: <Collection />,
              // errorElement: <ErrorBoundary />,
            },
            // {
            //   path: "/dashboard/:modelId",
            //   element: <DashboardLayout />,
            //   errorElement: <ErrorPage />,
            // },
          ],
        },
      ],
    },
  ];
};
